module.exports = __webpack_public_path__ + "img/__icon_CHŁODNIA.56266751.svg";